export default __webpack_public_path__ + "static/surgery-team-d5643b97960110a1cfcfb00f40579822.jpg";